import { Divider, Grid, Stack, Typography } from '@mui/material';
import ActionButton from 'common/components/ActionButton';
import EmptyView from 'common/features/noData/EmptyView';
import useFlexBoxStyles from 'common/flexBox';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { fetchRemaindersAction, getReminders, getRemindersPending } from 'redux/slices/iCalendarV4/reminderSlice';
import { openNestedDialog } from 'redux/slices/nestedDialogSlice';
import ICalendarReminderCreate from './ICalendarReminderCreate';
import ICalendarReminderEdit from './ICalendarReminderEdit';
import ICalendarReminderRow from './ICalendarReminderRow';

const ICalendarReminder = () => {
    const { t } = useTranslation();
    const { classes: flexBox, cx } = useFlexBoxStyles();
    const dispatch = useDispatch();
    const remainders = useSelector(getReminders);
    const pending = useSelector(getRemindersPending);

    useEffect(() => {
        dispatch(fetchRemaindersAction({ queryParams: { global: true } }));
    }, [dispatch]);

    const addReminder = (e) => {
        e.preventDefault();
        dispatch(openNestedDialog(<ICalendarReminderCreate />));
    };

    const handleEdit = (reminder) => {
        dispatch(openNestedDialog(<ICalendarReminderEdit reminder={reminder} />));
    };

    return (
        <Stack direction="column" spacing={2}>
            <Stack direction="row" justifyContent="space-between" alignItems="center">
                <Typography variant="onliveH5" fontWeight={500} className={cx(flexBox.h40)}>
                    {t('app.profile.settings.icalendar.reminder')}
                </Typography>
                <ActionButton disableElevation={false} onClick={addReminder} fitWidth={true}>
                    <span>{t('app.profile.settings.icalendar.addReminder')}</span>
                </ActionButton>
            </Stack>
            {remainders.length > 0 ? (
                <Stack direction="column" spacing={1}>
                    <Grid container spacing={0}>
                        <Grid item md={2}>
                            <Typography variant="onliveH6" fontWeight={500}>
                                {t('app.common.status')}
                            </Typography>
                        </Grid>
                        <Grid item md={3}>
                            <Typography variant="onliveH6" fontWeight={500}>
                                {t('game.gameItem.time')}
                            </Typography>
                        </Grid>
                        <Grid item md={3}>
                            <Typography variant="onliveH6" fontWeight={500}>
                                {t('iCalendar.reminder.delivery')}
                            </Typography>
                        </Grid>
                        <Grid item md={2}>
                            <Typography variant="onliveH6" fontWeight={500}>
                                {t('app.common.type')}
                            </Typography>
                        </Grid>
                        <Grid item md={2}></Grid>
                    </Grid>
                    <Divider />
                    {remainders.map((reminder) => (
                        <ICalendarReminderRow
                            reminder={reminder}
                            key={reminder.id}
                            handleEdit={() => handleEdit(reminder)}
                        />
                    ))}
                </Stack>
            ) : null}

            {!remainders?.length && !pending && (
                <Stack alignItems="center">
                    <EmptyView
                        description={t('iCalendar.appointment.empty')}
                        className={cx(
                            flexBox.sticky,
                            flexBox.flex,
                            flexBox.alignItemsCenter,
                            flexBox.top0,
                            flexBox.left0,
                        )}
                    />
                </Stack>
            )}
        </Stack>
    );
};

export default ICalendarReminder;
